const routes = [
    //样例
    {
        path: "/example",
        name: "example",
        component: resolve => require(["@/views/example"], resolve),
        meta: {
            // requireAuth: true
        }
    },
    {
        path: "/meetingApply",
        name: "meetingApply",
        component: resolve => require(["@/views/meetingApply/meetingApply"], resolve),
        meta: {
            title: "展会报名"
        }
    },
    // 登录
    {
        path: "/login",
        name: "login",
        component: resolve => require(["@/views/webview3"], resolve),
    },
    {
        path: "/webview",
        name: "webview",
        component: resolve => require(["@/views/webview"], resolve),
    },
    {
        path: "/webview2",
        name: "webview2",
        component: resolve => require(["@/views/webview2"], resolve),
    },
    {
        path: "/",
        name: "webview3",
        component: resolve => require(["@/views/webview3"], resolve),
    },
    {   //展商自定义登录页面
        path: "/exiLogin",
        name: "exiLogin",
        component: resolve => require(["@/views/exiLogin"], resolve),
    },
    {
        path: "/ExhibitClass",
        name: "ExhibitClass",
        component: resolve => require(["@/views/ExhibitClass/ExhibitClass"], resolve),
       
    },
    {
        path: "/ExhibitPrice",
        name: "ExhibitPrice",
        component: resolve => require(["@/views/ExhibitClass/ExhibitPrice"], resolve),
       
    },
    {
        path: "/extension",
        name: "extension",
        component: resolve => require(["@/views/ExhibitClass/extension"], resolve),
       
    },
    {
        path: "/",
        name: "index",
        component: resolve => require(["@/views/home"], resolve),
        meta: {
            title: '首页',
            keepAlive: true
        },
        children: [
          {
            path: "/appointmentList",
            name: "appointmentList",
            component: () => import("../views/appointmentList/appointmentList.vue"),
            meta: {
              keepAlive: false,
              needSelect: true
            }
          },
            // {
            //     path: "/",
            //     name: "exiIndex",
            //     component: resolve => require(["@/views/exiIndex/exiIndex"], resolve),
            //     meta: {}
            // },
            // {
            //     path: "/exiList",
            //     name: "exiList",
            //     component: resolve => require(["@/views/exiList"], resolve),
            //     meta: {}
            // },
            {
                path: "/exiList",
                name: "exiList",
                component: resolve => require(["@/views/exiList"], resolve),
                meta: {
                    keepAlive: false
                }
            },

            {
                path: "/hostUser",
                name: "hostUser",
                component: resolve => require(["@/views/companyUser/companyUser"], resolve),
                meta: {},
            },

            {
                path: "/companyList",
                name: "companyList",
                component: resolve => require(["@/views/companyList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/Dashboard",
                name: "Dashboard",
                component: resolve => require(["@/views/dashboard/dashboard"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/Regional",
                name: "Regional",
                component: resolve => require(["@/views/regional/regional"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/customForm",
                name: "customForm",
                component: resolve => require(["@/views/customForm/customForm"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/businessForm",
                name: "businessForm",
                component: resolve => require(["@/views/businessForm/businessForm"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/queststat",
                name: "queststat",
                component: resolve => require(["@/views/queststat/queststat"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/purchasesta",
                name: "purchasesta",
                component: resolve => require(["@/views/purchasesta/purchasesta"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/vipManage",
                name: "vipManage",
                component: resolve => require(["@/views/vipManage/vipManage"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/Vipinterests",
                name: "Vipinterests",
                component: resolve => require(["@/views/Vipinterests/index"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/incentiveList",
                name: "incentiveList",
                component: resolve => require(["@/views/incentiveList/incentiveList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/customOrderList",
                name: "customOrderList",
                component: resolve => require(["@/views/customOrderList/customOrderList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/vandRoom",
                name: "vandRoom",
                component: resolve => require(["@/views/vandRoom/vandRoom"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },

            {
                path: "/contentCategory",
                name: "contentCategory",
                component: resolve => require(["@/views/contentCategory/contentCategory"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/partner",
                name: "partner",
                component: resolve => require(["@/views/partner/partner"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/editArtical",
                name: "editArtical",
                component: resolve => require(["@/views/editArtical/editArtical"], resolve),
                meta: {}
            },
            {
                path: "/editExi",
                name: "editExi",
                component: resolve => require(["@/views/editExi/editExi"], resolve),
                meta: {}
            },
            {
                path: "/editCompany",
                name: "editCompany",
                component: resolve => require(["@/views/editCompany/editCompany"], resolve),
                meta: {}
            },
            {
                path: "/editProduct",
                name: "editProduct",
                component: resolve => require(["@/views/editProduct/editProduct"], resolve),
                meta: {}
            },
            {
                path: "/meetingList",
                name: "meetingList",
                component: resolve => require(["@/views/meetingList/meetingList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/maintainAdPlace",
                name: "maintainAdPlace",
                component: resolve => require(["@/views/maintainAdPlace/maintainAdPlace"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/exiScene",
                name: "exiScene",
                component: resolve => require(["@/views/exiScene/exiScene"], resolve),
                meta: {}
            },
            {
                path: "/meetingVisitor",
                name: "meetingVisitor",
                component: resolve => require(["@/views/meetingVisitor/meetingVisitor"], resolve),
                meta: {}
            },
            {
                path: "/exiReserveList",
                name: "exiReserveList",
                component: resolve => require(["@/views/exiReserveList/exiReserveList"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/userCardList",
                name: "userCardList",
                component: resolve => require(["@/views/userCardList/userCardList"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/editMeeting",
                name: "editMeeting",
                component: resolve => require(["@/views/editMeeting/editMeeting"], resolve),
                meta: {}
            },
            {
                path: "/editAdver",
                name: "editAdver",
                component: resolve => require(["@/views/editAdver/editAdver"], resolve),
                meta: {}
            },
            {
                path: "/proList",
                name: "proList",
                component: resolve => require(["@/views/proList/proList"], resolve),
                meta: {}
            },
            {
                path: "/companyUser",
                name: "companyUser",
                component: resolve => require(["@/views/companyUser/companyUser"], resolve),
                meta: {}
            },
            {
                path: "/companySample",
                name: "companySample",
                component: resolve => require(["@/views/companySample/companySample"], resolve),
                meta: {}
            },
            {
                path: "/companyVisitor",
                name: "companyVisitor",
                component: resolve => require(["@/views/companyVisitor/companyVisitor"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/VisitorSign",
                name: "VisitorSign",
                component: resolve => require(["@/views/VisitorSign/VisitorSign"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/Analysis",
                name: "Analysis",
                component: resolve => require(["@/views/analysis/analysis"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/exhibitorVisitor",
                name: "exhibitorVisitor",
                component: resolve => require(["@/views/exhibitorVisitor/exhibitorVisitor"], resolve),
                meta: {
                    needSelect: true
                }
            },
          
            {
                path: "/recommendCmp",
                name: "recommendCmp",
                component: resolve => require(["@/views/recommendCmp"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/recommendPro",
                name: "recommendPro",
                component: resolve => require(["@/views/recommendPro"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/exiFiles",
                name: "exiFiles",
                component: resolve => require(["@/views/exiFiles/exiFiles"], resolve),
                meta: {
                    needSelect: true
                }
            },
            {
                path: "/buildList",
                name: "buildList",
                component: resolve => require(["@/views/buildList/buildList"], resolve),
                meta: {}
            },
            {
                path: "/editBuild",
                name: "editBuild",
                component: resolve => require(["@/views/editBuild/editBuild"], resolve),
                meta: {}
            },
            // {
            //     path: "/signupList",
            //     name: "signupList",
            //     component: resolve => require(["@/views/signupList/signupList"], resolve),
            //     meta: {}
            // },
            //日志管理
            {
                path: "/exiProlist",
                name: "exiProlist",
                component: resolve => require(["@/views/exiProlist/exiProlist"], resolve),
                meta: {
                    // requireAuth: true
                    needSelect: true
                }
            },
            // 订单管理
            {
                path: "/orderList",
                name: "orderList",
                component: resolve => require(["@/views/orderList/orderList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            //全局附件管理
            {
                path: "/comfileLog",
                name: "comfileLog",
                component: resolve => require(["@/views/log/comfileLog"], resolve),
                meta: {
                    // requireAuth: true
                }
            },
            //全局参数管理
            {
                path: "/basCategory",
                name: "basCategory",
                component: resolve => require(["@/views/log/basCategory"], resolve),
                meta: {
                    // requireAuth: true
                }
            },
            //全局参数管理
            {
                path: "/ucLog",
                name: "ucLog",
                component: resolve => require(["@/views/log/ucLog"], resolve),
                meta: {
                    // requireAuth: true
                }
            },
            {
                path: "/decorator",
                name: "decorator",
                component: resolve => require(["@/views/decorator/decorator"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            {
                path: "/decoratorConfig",
                name: "decoratorConfig",
                component: resolve => require(["@/views/decoratorConfig/decoratorConfig"], resolve),
                meta: {
                    keepAlive: true,
                    // needSelect: true
                }
            },
            {
                path: "/editDecoratorConfig",
                name: "editDecoratorConfig",
                component: resolve => require(["@/views/editDecoratorConfig/editDecoratorConfig"], resolve),
                meta: {}
            },
            // 引荐管理
            {
                path: "/Recommend",
                name: "Recommend",
                component: resolve => require(["@/views/Recommend"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            // 图片直播列表
            {
                path: "/liveList",
                name: "liveList",
                component: resolve => require(["@/views/liveList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            // 注册表单
            {
                path: "/fromList",
                name: "fromList",
                component: resolve => require(["@/views/fromList/fromList"], resolve),
                meta: {
                    keepAlive: true,
                    needSelect: true
                }
            },
            // 样本中心，非公司样本
            {
                path: "/sampleList",
                name: "sampleList",
                component: resolve => require(["@/views/sampleList/sampleList"], resolve),
                // meta: { keepAlive: true }
            },
            // 样本详情
            {
                path: "/brochuresPages",
                name: "brochuresPages",
                component: resolve => require(["@/views/brochuresPages"], resolve),
                // meta: { keepAlive: true }
            },
            // 样本访客
            {
                path: "/sampleVisitor",
                name: "sampleVisitor",
                component: resolve => require(["@/views/sampleVisitor"], resolve),
                meta: {
                    keepAlive: true
                }
            },
            // 样本信息收集表单
            {
                path: "/sampleForm",
                name: "sampleForm",
                component: resolve => require(["@/views/sampleForm/sampleForm"], resolve)
            },
            // 样本信息表单记录
            {
                path: "/sampleFormRecord",
                name: "sampleFormRecord",
                component: resolve => require(["@/views/sampleFormRecord/sampleFormRecord"], resolve)
            },
            // 样本目录维护
            {
                path: "/sampleCatalogue",
                name: "sampleCatalogue",
                component: resolve => require(["@/views/sampleCatalogue"], resolve)
            },
            // 样本文本维护
            {
                path: "/sampleEditPage",
                name: "sampleEditPage",
                component: resolve => require(["@/views/sampleEditPage"], resolve)
            }
        ],
    },
    // 主办方门户
    {
        path: "/portalHome",
        name: "portalHome",
        component: resolve => require(["@/views/portalHome/portalHome"], resolve),
        meta: {
            needBanner: true, keepAlive: true
        },
        children: [
            // 独立展商首页
            {
                path: "/exhIndex",
                name: "exhIndex",
                component: resolve => require(["@/views/exhIndex"], resolve),
                meta: {
                    keepAlive: true
                }
            },
            // 展馆
            {
                path: "/comList",
                name: "comList",
                component: resolve => require(["@/views/comList"], resolve),
                meta: {
                    keepAlive: false
                }
            },
            // 新闻
            {
                path: "/newsList",
                name: "newsList",
                component: resolve => require(["@/views/newsList"], resolve),
                meta: {
                    keepAlive: true
                }
            },
            // 会议活动
            {
                path: "/actives",
                name: "actives",
                component: resolve => require(["@/views/actives"], resolve),
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/portalNewsInfo",
                name: "portalNewsInfo",
                component: resolve => require(["@/views/portalNewsInfo"], resolve),
                meta: { keepAlive: false, needBanner: true }
            },
            {
                path: "/portalMeetingInfo",
                name: "portalMeetingInfo",
                component: resolve => require(["@/views/portalMeetingInfo"], resolve),
                meta: { keepAlive: false, needBanner: false }
            },
            {
                path: "/portalProductInfo",
                name: "portalProductInfo",
                component: resolve => require(["@/views/portalProductInfo"], resolve),
                meta: { keepAlive: false, needBanner: false }
            },
            {
                path: "/portalComInfo",
                name: "portalComInfo",
                component: resolve => require(["@/views/portalComInfo"], resolve),
                meta: { keepAlive: false, needBanner: false }
            }
        ]
    },


    //404
    {
        path: '*',
        redirect: '/'
    }
]
export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js